import { render, staticRenderFns } from "./WeekOverViewLink.vue?vue&type=template&id=1a1009f7&scoped=true&"
import script from "./WeekOverViewLink.vue?vue&type=script&lang=js&"
export * from "./WeekOverViewLink.vue?vue&type=script&lang=js&"
import style0 from "./WeekOverViewLink.vue?vue&type=style&index=0&id=1a1009f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1009f7",
  null
  
)

export default component.exports